import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import useAppDispatch from 'hooks/common/useAppDispatch';
import terms from 'i18n';
import { EmailFormData } from 'models/auth';
import { createToast } from 'redux/actions';
import { useEmailMutation } from 'redux/api/common/auth-api';
import regexp from 'utils/regexp';

const useSignUpEmailForm = () => {
  const [sendEmail] = useEmailMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [btnDisabled, setBtnDisabled] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<EmailFormData>({
    mode: 'onChange',
  });

  const isConsentChecked = watch('consentToDataProcessing');
  const isPrivacyChecked = watch('privacyPolicyAgreement');

  const fields = {
    email: register('email', {
      required: terms.REQUIRED_FIELD,
      pattern: {
        value: regexp.email,
        message: terms.VALID_EMAIL,
      },
    }),
    consentToDataProcessing: register('consentToDataProcessing', {
      required: terms.REQUIRED_FIELD,
    }),
    privacyPolicyAgreement: register('privacyPolicyAgreement', {
      required: terms.REQUIRED_FIELD,
    }),
  };

  const onSubmit = handleSubmit(async (data: EmailFormData) => {
    try {
      await sendEmail({ email: data.email }).unwrap();
      navigate('/sign-up/code', { state: { email: data.email } });
      dispatch(createToast(terms.EMAIL_SUCCESS, 'success'));
    } catch (error: any) {
      const status = error?.status;
      const headers = error?.meta?.response?.headers;

      if (status === 429) {
        const retryAfter = headers?.get('Retry-After');
        setBtnDisabled(true);
        setTimeout(() => setBtnDisabled(false), Number(retryAfter) * 1000);
        dispatch(createToast(terms.TOO_MANY_ATTEMPTS, 'danger'));
      } else if (status === 409) {
        dispatch(createToast(terms.EMAIL_EXISTS, 'danger'));
      } else {
        dispatch(createToast(terms.EMAIL_ERROR, 'danger'));
      }
    }
  });

  return {
    fields,
    onSubmit,
    btnDisabled,
    errors,
    isConsentChecked,
    isPrivacyChecked,
  };
};

export default useSignUpEmailForm;
